import React, { useEffect, useRef } from 'react';
import { Order, OrderStatus } from '../../lib/types';
import { StatusPill } from '../ui';
import { ALL_STATUSES } from './types';

interface StatusDropdownProps {
  order: Order;
  anchor: { top: number; left: number; btnTop: number };
  onSelect: (order: Order, newStatus: OrderStatus) => void;
  onClose: () => void;
}

export function StatusDropdown({ order, anchor, onSelect, onClose }: StatusDropdownProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose();
    };
    document.addEventListener('mousedown', handler);
    const onScroll = () => onClose();
    window.addEventListener('scroll', onScroll, true);
    return () => {
      document.removeEventListener('mousedown', handler);
      window.removeEventListener('scroll', onScroll, true);
    };
  }, [onClose]);

  const flip = anchor.top + 200 > window.innerHeight;

  return (
    <div
      ref={ref}
      className="menu"
      style={{
        position: 'fixed',
        top: flip ? anchor.btnTop : anchor.top,
        left: anchor.left,
        transform: flip ? 'translateY(-100%)' : 'none',
        minWidth: 150,
        padding: 4,
      }}
    >
      {ALL_STATUSES.map(s => (
        <button
          key={s}
          className={`menu-item ${s === order.status ? 'is-active' : ''}`}
          onClick={() => onSelect(order, s)}
          style={{ padding: '6px 10px' }}
        >
          {s === order.status
            ? <span style={{ fontSize: 11, color: 'var(--accent)', width: 12 }}>✓</span>
            : <span style={{ width: 12 }} />}
          <StatusPill status={s} compact />
        </button>
      ))}
    </div>
  );
}
